import common from './common'

function setLocalStorageItem (key, obj) {
  var objstr = ''
  if (obj !== null) {
    if (common.getTypeStr(obj) === 'string') {
      objstr = obj.trim()
    } else if (common.getTypeStr(obj) === 'object') {
      objstr = JSON.stringify(common.filterNull(obj))
    } else if (common.getTypeStr(obj) === 'array') {
      objstr = JSON.stringify(common.filterNull(obj))
    }
  }
  localStorage.setItem(key, objstr)
}

function getLocalStorageItem (key) {
  var objstr = localStorage.getItem(key)
  if (objstr !== undefined && objstr !== null && objstr !== '') {
    return JSON.parse(objstr)
  } else {
    return objstr
  }
}

function removeLocalStorageItem (key) {
  localStorage.removeItem(key)
}

export default {
  setItem (key, obj) {
    return setLocalStorageItem(key, obj)
  },
  getItem (key) {
    return getLocalStorageItem(key)
  },
  removeItem (key) {
    return removeLocalStorageItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/utils/local-storage-service.js